export const BROWSERS = {
  CHROME: "chrome",
  EDGE: "edge",
  OTHER: "other",
};

// Only Chrome and Edge get install steps: both install straight from the
// Chrome Web Store. Edge's user agent also contains "Chrome/", so it is
// checked first; Opera ("OPR/") needs an extra add-on, so it counts as other.
export const detectBrowser = (userAgent = navigator.userAgent) => {
  if (/Edg\//.test(userAgent)) return BROWSERS.EDGE;
  if (/Chrome\//.test(userAgent) && !/OPR\//.test(userAgent)) return BROWSERS.CHROME;

  return BROWSERS.OTHER;
};
